<template>
  <HTag size="large" :color="color" class="form-list-item">
    {{ description }}

    <button
      v-if="removable"
      class="form-list-item__remove"
      tabindex="0"
      transparent
      :disabled="readonly"
      @click="removeItem(index)"
      @keyup.enter="removeItem(index)"
    >
      <WIcon color="gl-color-shades-gray-80" icon="icClose" />
    </button>
  </HTag>
</template>

<script>
import { WIcon } from '@alice-health/wonderland-vue'

import { HTag } from '@/components/shared/atoms'
import showDescription from '@/utils/showDescription'

export default {
  name: 'FormListItem',
  components: {
    HTag,
    WIcon
  },
  props: {
    value: { type: [Object, String], default: undefined },
    index: { type: Number, default: undefined },
    readonly: Boolean,
    removable: Boolean,
    removeItem: { type: Function, default: () => undefined },
    color: { type: String, default: undefined }
  },
  computed: {
    description() {
      return showDescription(this.value)
    }
  }
}
</script>

<style lang="scss">
.form-list-item {
  align-items: center;

  &__remove {
    &[transparent] {
      padding: 0;
    }
  }
}
</style>
